import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { IconButton, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import { Box } from '@mui/system'
import PreviewAnexo, { isImage } from 'global/components/Anexo'
import Dialog from 'global/guides/Dialog'
import { DownloadIcon, PaperclipIcon } from 'lucide-react'
import React, { useState } from 'react'
import { uploads } from 'service/api/endpoints/uploads'

const VisualizarAnexoModal: React.FC<GridCellParams> = ({ value }) => {
    const [open, setOpen] = useState(false)

    if (!value) return null
    const source = `${uploads.URI}/${value}`

    return (
        <>
            <Button onClick={() => setOpen(true)} endIcon={<PaperclipIcon />}>
                Exibir
            </Button>
            <Dialog.Root
                height="75vh"
                open={open}
                onClose={() => setOpen(false)}
            >
                <Dialog.Title>
                    <Typography>Visualizar anexo</Typography>
                    <IconButton
                        sx={{ float: 'right' }}
                        title="Baixar anexo"
                        href={source}
                        target="_blank"
                        rel="external"
                    >
                        <DownloadIcon />
                    </IconButton>
                </Dialog.Title>
                <Dialog.Content
                    sx={{
                        overflowY: 'clip',
                        maxHeight: '100%',
                        display: 'flex',
                    }}
                >
                    <Box
                        sx={{
                            margin: 'auto',
                            maxWidth: isImage(value.split('.').pop()!)
                                ? '22rem'
                                : '40rem',
                            width: '100%',
                            maxHeight: '100%',
                            overflowY: 'clip',
                        }}
                    >
                        <PreviewAnexo
                            source={source}
                            ext={value.split('.').pop()!}
                        />
                    </Box>
                </Dialog.Content>
                <Dialog.Actions>
                    <Dialog.Actions.SecondaryButton />
                </Dialog.Actions>
            </Dialog.Root>
        </>
    )
}

export default VisualizarAnexoModal
